import React, { useContext, useEffect, useRef, useState } from 'react'

import NotificationIconEnable from 'assets/icons/notification-icon-enable'
import NotificationIconNoNotification from 'assets/icons/notification-icon'
import { FormattedMessage } from 'react-intl'
import MailIcon from 'assets/icons/mail-icon'
import FileWarningIcon from 'assets/icons/file-warning-icon'
import ActionsMenu from '../ActionMenu'
import InfoFileIcon from 'assets/icons/info-file-icon'
import { notificationType } from './notificationType'
import { requestGetNotifications, requestReadNotifications } from 'api/user'
import { SECRETARIAT_ROLE_DECLINE_ID, REMOVE_CO_PROPOSER_NOTIFICATION_TYPE_ID } from 'constants/notificationTypes'

import {
  NotificationDivider,
  NotificationsAmount,
  TopBarNotificationContainer,
  TopBarNotificationIcon,
  TopBarNotificationMenuHeader,
  TopBarNotificationMenuItem,
  TopBarNotificationMenuItemIcon,
  TopBarNotificationMenuItemText,
  TopBarNotificationMenuNotificationsList,
  TopBarNotificationMenuNotificationsListNoNotifications,
  TopBarNotificationMenuWrapper,
  TopBarNotificationWrapper
} from './style'
import { SocketContext } from '../../providers/socket'

const NotificationIcon = ({ ...props }) => {
  const { socket } = useContext(SocketContext)
  const [isOpenNotificationsList, setIsOpenNotificationsList] = useState(false)
  const [notification, setNotification] = useState([])
  const notificationList = useRef()
  const notificationIcon = useRef()
  const newNotification = notification.filter((item) => {
    return item.isDismissed === false
  })

  const getNotification = () => {
    requestGetNotifications().then((data) => {
      setNotification(() => {
        return data.notifications.map((item) => {
          return { ...item, data: JSON.parse(item.data) }
        })
      })
    })
  }

  function closeNotificationMenuOnOutsideClick(e) {
    if (notificationList.current.contains(e.target) || notificationIcon.current.contains(e.target)) {
      return
    }
    e.stopPropagation()
    setIsOpenNotificationsList(false)
    getNotification()
  }

  useEffect(() => {
    document.addEventListener('mousedown', closeNotificationMenuOnOutsideClick)

    return () => {
      document.removeEventListener('mousedown', closeNotificationMenuOnOutsideClick)
    }
  }, [])

  function openNotificationListHandler() {
    setIsOpenNotificationsList(!isOpenNotificationsList)
    requestReadNotifications()
    if (isOpenNotificationsList) {
      getNotification()
    }
  }

  useEffect(() => {
    socket.on('notification', (data) => {
      const note = {
        ...data,
        NotificationTypeId: data.NotificationTypeId ?? data.notificationType,
        isDismissed: data.isDismissed ?? false,
        createdAt: data.createdAt || new Date().toISOString()
      }
      setNotification([note, ...notification])
    })
  }, [])

  const notificationsList = notification.map((note, index) => {
    const renderNotification = notificationType[note.NotificationTypeId]
    if (!renderNotification) return null

    return (
      <>
        <TopBarNotificationMenuItem key={index} isDismissed={note.isDismissed}>
          <TopBarNotificationMenuItemIcon
            isDismissed={note.isDismissed}
            isDestructive={
              note.NotificationTypeId === SECRETARIAT_ROLE_DECLINE_ID ||
              note.NotificationTypeId === REMOVE_CO_PROPOSER_NOTIFICATION_TYPE_ID
            }
          >
            {note.NotificationTypeId === SECRETARIAT_ROLE_DECLINE_ID ||
            note.NotificationTypeId === REMOVE_CO_PROPOSER_NOTIFICATION_TYPE_ID ? (
                <FileWarningIcon />
              ) : (
                <InfoFileIcon />
              )}
          </TopBarNotificationMenuItemIcon>
          <TopBarNotificationMenuItemText>
            {renderNotification(note.data, note.createdAt)}
          </TopBarNotificationMenuItemText>
        </TopBarNotificationMenuItem>
        {/* eslint-disable-next-line no-magic-numbers */}
        {index + 1 < notification.length && <NotificationDivider />}
      </>
    )
  })

  useEffect(() => {
    getNotification()
  }, [])

  return (
    <TopBarNotificationContainer>
      <TopBarNotificationWrapper {...props}>
        {newNotification.length ? <NotificationsAmount>{newNotification.length}</NotificationsAmount> : <></>}
        <TopBarNotificationIcon ref={notificationIcon} onClick={openNotificationListHandler}>
          {newNotification.length ? <NotificationIconEnable /> : <NotificationIconNoNotification />}
        </TopBarNotificationIcon>
      </TopBarNotificationWrapper>
      <>
        <TopBarNotificationMenuWrapper
          data-test="notification-list-container"
          ref={notificationList}
          open={isOpenNotificationsList}
        >
          <TopBarNotificationMenuHeader>
            <div>
              <FormattedMessage id="notifications" />
            </div>
            <ActionsMenu />
          </TopBarNotificationMenuHeader>
          {notification.length ? (
            <TopBarNotificationMenuNotificationsList className="scroll">
              {notificationsList}
            </TopBarNotificationMenuNotificationsList>
          ) : (
            <TopBarNotificationMenuNotificationsListNoNotifications>
              <MailIcon />
              <div>
                <FormattedMessage id="nothingHereSoFar" />
              </div>
            </TopBarNotificationMenuNotificationsListNoNotifications>
          )}
        </TopBarNotificationMenuWrapper>
      </>
    </TopBarNotificationContainer>
  )
}

export default NotificationIcon
